import { keyBy } from '@exodus/basic-utils';
import { atom } from '@exodus/headless-ui';
import fromWalletAccountAtom from './from-wallet-account.js';
const fromAssetsAtom = atom((get, { selectors }) => {
    const allAssets = get(selectors.assets.all);
    const fromWalletAccount = get(fromWalletAccountAtom);
    const supportedIds = get(selectors.exchange.fromAssetIds);
    const enabledFromAssetsNames = get(selectors.assetSources.createEnabledAssetsByWalletAccount(fromWalletAccount.toString()));
    const enabledAssets = [...enabledFromAssetsNames]
        .map((assetName) => allAssets[assetName])
        .filter((asset) => !!asset);
    const assetsByTicker = keyBy(enabledAssets, 'ticker');
    return supportedIds.map((id) => assetsByTicker[id]).filter((asset) => !!asset);
});
export default fromAssetsAtom;
